import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class videoPerformance_template extends vnTemplate{

    protected brandsFilter : multipleSelector_template;
    protected intentsFilter : multipleSelector_template;
    protected contentTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected countryFilter : multipleSelector_template;
    protected datesFilter: filterDate_template;
    protected exportCsv: exportDataCsv;
    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    protected videoViewHeaders: simpleListHeader_template;
    protected pagination: pagination_template;

    readonly viewModes = [
        { "id": "daily", "name": "daily"},
        { "id": "video", "name": "video"},
    ];

    readonly countries = [
        {"id": "US", "name": "United States"},
        {"id": "CA", "name": "Canada"},
        {"id": "GB", "name": "United Kingdom"},
        {"id": "AU", "name": "Australia"},
        {"id": "Other", "name": "Other"},
    ];

    readonly devices = [
        {"id": "all", "name": "All"},
        {"id": "mobile", "name": "Mobile"},
        {"id": "desktop", "name": "Desktop"},
    ];

    readonly operatingSystems = [
        {"id": "Android", "name": "Android"},
        {"id": "iOS", "name": "iOS"},
    ];

    readonly outputs = [
        { "id": "all", "name": "all"},
        { "id": "new", "name": "new"},
        { "id": "leveraged", "name": "leveraged"}
    ];

    readonly publishStatuses = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];

    readonly placements = [
        { "id": "all", "name": "all"},
        { "id": "featured", "name": "featured"},
        { "id": "in-content", "name": "in-content"}
    ];



    protected getTemplateHtml(): string{

        return /*html*/`
            <div class="sub-header w-justify">

                ${this.presetFilter.getHtmlBuild()}

                <div class="w-left">
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelected"></button>
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                     
                    ${this.brandsFilter.getHtmlBuild()} 
                    ${this.intentsFilter.getHtmlBuild()} 
                    ${this.contentTypesFilter.getHtmlBuild()} 
                    ${this.networkCategoriesFilter.getHtmlBuild()}
                    ${this.countryFilter.getHtmlBuild()}
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Device Options</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: deviceSelectedText"></button>
                        
                        <div class="dropdown-list"> 
                            <div class="w-form">                        
                                <div class="form-group" data-bind="foreach: devices">
                                    <input type="radio" data-bind="checked : $parent.deviceSelected, value: id,  attr: { 'id': 'device_' + id, 'name' : 'device_' + id }, event:{ change: $parent.onDeviceChange}">
                                    <label class="form-label" data-bind="attr: {for : 'device_' + id }, text: name"></label>
                                    <!-- ko if: id == 'mobile' -->
                                        <div class="form-group" data-bind="foreach: $parents[0].operatingSystems">
                                            <input type="radio" data-bind="checked : $parents[1].operatingSystemSelected, value: id,  attr: { 'id': 'mobileOs_' + id, 'name' : 'mobileOs_' + id }, event:{ change: $parents[1].onOperatingSystemChange}">
                                            <label class="form-label" data-bind="attr: {for : 'mobileOs_' + id }, text: name"></label>
                                        </div>
                                    <!-- /ko -->
                                </div>
                            </div>
                        </div>
                    </div>

                    ${this.datesFilter.getHtmlBuild()}

                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'video'">
                        <label class="form-label" for="">Placement</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: placementSelected"></button>
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: placements">
                                    <input type="radio" data-bind="checked : $parent.placementSelected, value: id,  attr: { 'id': 'placement_' + id, 'name' : 'placement_' + id }, event:{ change: $parent.onPlacementChange}">
                                    <label class="form-label" data-bind="attr: {for : 'placement_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: publishStatuses">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'daily'">
                        <label class="form-label" for="">Output</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: outputSelected"></button>
                        <div class="dropdown-list"> 
                            <div class="w-form">   
                                <div class="form-group" data-bind="foreach: outputs">
                                    <input type="radio" data-bind="checked : $parent.outputSelected, value: id,  attr: { 'id': 'output_' + id, 'name' : 'output_' + id }, event:{ change: $parent.onOutputChange}">
                                    <label class="form-label" data-bind="attr: {for : 'output_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
             
                 
            </div>
            
            ${this.validationsList.getHtmlBuild()}
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-intents"></div>
                    <div id="selected-content_types"></div>
                    <div id="selected-network_categories"></div>
                    <div id="selected-countries"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-sheet">Video Performance Report</h2>                    
                </div>
                <div class="w-right">
                                   
                    <button class="btn highlight icon fix-width i-expand" type="button" data-bind="visible: viewModeSelected() == 'daily', css: collapseButtonClass(), text: collapseButtonText(), event: { click: onCollapseClick}">Simplify</button>
                    
                    <button class="btn icon highlight i-export" type="button" data-bind="visible: viewModeSelected() == 'daily', event: { click: exportDailyData}, css: { 'is-hidden': exportDailyButtonHidden }">Export</button>
                                
                    <!-- ko if: viewModeSelected() == 'video' -->
                    ${this.pagination.getHtmlBuild()}
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportVideoData}, css: { 'is-hidden': exportVideoButtonHidden }">Export</button>
                    <!-- /ko -->
                </div>
            </div>

            <!-- ko if: viewModeSelected() == 'daily' -->
            
            <div class="w-list-results" id="list-results" style="padding-bottom: 200px">

                <table class="list-results list-sections thin video_performance " style="padding-bottom: 200px;">
                    <thead>
                        <tr class="list-header-section no-shadow"> 
                            <th class="border-right sticky-col" style="box-shadow: none;width: 60px" rowspan="2"><span></span></th>
                            
                            <th class="colgroup-3 end" colspan="3"><span class="align-center">All</span></th>
                            
                            <th class="colgroup-4 end" data-bind="attr: { colspan: revenuePermissions() ? placementColumnNumber() : placementColumnNumber() - 2 }"><span class="align-center">Featured</span></th>
                            
                            <th class="colgroup-1 end" data-bind="attr: { colspan: revenuePermissions() ? placementColumnNumber() : placementColumnNumber() - 2 }"><span class="align-center">Embeds</span></th>
                            
                            <th class="colgroup-5 end" data-bind="attr: { colspan: revenuePermissions() ? placementColumnNumber() - 1 : placementColumnNumber() - 3 }"><span class="align-center">Video Shorts</span></th>
                            
                            <!-- ko if: revenuePermissions -->
                            <th class="colgroup-2" colspan="2"><span class="align-center">Total Daily Revenue</span></th>
                            <!-- /ko -->
                        </tr>   
                        
                        <tr class="list-header-section no-shadow data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                            <!--Sub Headers for All-->

                            <th class="colgroup-3"><span class="align-center">Output</span></th>
                            <th class="colgroup-3"><span class="align-center">Views</span></th>
                            <th class="colgroup-3 end"><span class="align-center">Imp/View</span></th>

                            <!--Sub Headers for Featured-->
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">Output</span></th>
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">Views</span></th>
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">CTR</span></th>
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">Imp/View</span></th>
                            <th class="colgroup-4 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">5 Sec Plays</span></th>
                            <th class="colgroup-4 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">30 Sec Plays</span></th>
                            <th class="colgroup-4 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">60 Sec Plays</span></th>
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">Engaged Views</span></th>
                            <th class="colgroup-4" style="width:70px;" data-bind="class: revenuePermissions() ? 'colgroup-4' : 'colgroup-4 end'"><span class="align-center">Avg. Views/Video</span></th>
                            <!-- ko if: revenuePermissions -->
                            <th class="colgroup-4" style="width:70px;"><span class="align-center">Revenue</span></th>                           
                            <th class="colgroup-4 end" style="width:70px;"><span class="align-center">RPM</span></th>   
                            <!-- /ko -->
                            
                            <!--Sub Headers for Embeds-->
                            <th class="colgroup-1" style="width:70px;"><span class="align-center">Output</span></th>
                            <th class="colgroup-1" style="width:70px;"><span class="align-center">Views</span></th>
                            <th class="colgroup-1" style="width:70px;"><span class="align-center">CTR</span></th>
                            <th class="colgroup-1" style="width:70px;"><span class="align-center">Imp/View</span></th>
                            <th class="colgroup-1 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">5 Sec Plays</span></th>
                            <th class="colgroup-1 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">30 Sec Plays</span></th>
                            <th class="colgroup-1 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">60 Sec Plays</span></th>
                            <th class="colgroup-1" style="width:70px;"><span class="align-center">Engaged Views</span></th>
                            <th class="colgroup-1" style="width:70px;" data-bind="class: revenuePermissions() ? 'colgroup-1' : 'colgroup-1 end'"><span class="align-center">Avg. Views/Video</span></th>
                            <!-- ko if: revenuePermissions -->
                            <th style="width:70px;" class="colgroup-1"><span class="align-center">Revenue</span></th>                           
                            <th style="width:70px;" class="colgroup-1 end"><span class="align-center">RPM</span></th> 
                            <!-- /ko -->

                            <!--Sub Headers for Video Shorts-->
                            <th class="colgroup-5" style="width:70px;"><span class="align-center">Output</span></th>
                            <th class="colgroup-5" style="width:70px;"><span class="align-center">Views</span></th>
                            <th class="colgroup-5" style="width:70px; display: none;"><span class="align-center">CTR</span></th>
                            <th class="colgroup-5" style="width:70px;"><span class="align-center">Imp/View</span></th>
                            <th class="colgroup-5 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">5 Sec Plays</span></th>
                            <th class="colgroup-5 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">30 Sec Plays</span></th>
                            <th class="colgroup-5 expanded-cells" data-bind="visible: collapseButtonText() == 'simplify'" style="width:70px;"><span class="align-center">60 Sec Plays</span></th>
                            <th class="colgroup-5" style="width:70px;"><span class="align-center">Engaged Views</span></th>
                            <th class="colgroup-5" style="width:70px;" data-bind="class: revenuePermissions() ? 'colgroup-5' : 'colgroup-5 end'"><span class="align-center">Avg. Views/Video</span></th>
                            <!-- ko if: revenuePermissions -->
                            <th style="width:70px;" class="colgroup-5"><span class="align-center">Revenue</span></th>                           
                            <th style="width:70px;" class="colgroup-5 end"><span class="align-center">RPM</span></th> 
                            <!-- /ko -->

                            <!--Sub Headers for Revenue-->
                            <!-- ko if: revenuePermissions -->
                            <th style="width:70px;" class="colgroup-2"><span class="align-center">Revenue</span></th>                           
                            <th style="width:70px;" class="colgroup-2"><span class="align-center">RPM</span></th>                            
                            <!-- /ko -->
                        </tr>   
                    </thead>
                    
                    <tbody data-bind="foreach: dailyData">
                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                        
                            <td class="border-right"><span class="no-wrap" data-bind="text: dateData"></span></td>

                            <td class="align-right"><span data-bind="text: Number(allOutput).toLocaleString('en-EG')"></span></td>
                            <td class="align-right"><span data-bind="text: Number(allViews).toLocaleString('en-EG')"></span></td>
                            <td class="align-right border-right"><span data-bind="text: Number(allImpPerView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            
                            <td class="align-right"><span data-bind="text: Number(featuredOutput).toLocaleString('en-EG')"></span></td>
                            <td class="align-right"><span data-bind="text: Number(featuredViewCount).toLocaleString('en-EG')"></span></td>
                            <td class="align-right"><span data-bind="text: Number(featuredCtr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right"><span data-bind="text: Number(featuredImpPerView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="colgroup-4 align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(featuredPlayCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-4 align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(featuredPlayCount30sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="colgroup-4 align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: Number(featuredPlayCount60sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right"><span data-bind="text: Number(featuredEngagedCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right" data-bind="class: $parent.revenuePermissions() ? '' : 'end'"><span data-bind="text: Number(featuredAvgViews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- ko if: $parent.revenuePermissions -->
                            <td class="align-right colgroup-4 end"><span data-bind="text: Number(featuredRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right colgroup-4 end"><span data-bind="text: Number(featuredRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <td class="align-right"><span data-bind="text: Number(embedOutput).toLocaleString('en-EG')"></span></td>
                            <td class="align-right"><span data-bind="text: Number(embedViewCount).toLocaleString('en-EG')"></span></td>
                            <td class="align-right"><span data-bind="text: Number(embedCtr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right"><span data-bind="text: Number(embedImpPerView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(embedPlayCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(embedPlayCount30sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right expanded-cells" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(embedPlayCount60sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right"><span data-bind="text: Number(embedEngagedCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right" data-bind="class: $parent.revenuePermissions() ? '' : 'end'"><span data-bind="text: Number(embedAvgViews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- ko if: $parent.revenuePermissions -->
                            <td class="align-right colgroup-1 end"><span class="colgroup-1" data-bind="text: Number(embedRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right colgroup-1 end"><span data-bind="text: Number(embedRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <td class="align-right colgroup-5"><span data-bind="text: Number(videoShortsOutput).toLocaleString('en-EG')"></span></td>
                            <td class="align-right colgroup-5"><span data-bind="text: Number(videoShortsViewCount).toLocaleString('en-EG')"></span></td>
                            <td class="align-right colgroup-5" style="display: none;"><span data-bind="text: Number(videoShortsCtr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right colgroup-5"><span data-bind="text: Number(videoShortsImpPerView).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right expanded-cells colgroup-5" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(videoShortsPlayCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right expanded-cells colgroup-5" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(videoShortsPlayCount30sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right expanded-cells colgroup-5" data-bind="visible: $parent.collapseButtonText() == 'simplify'" ><span data-bind="text: Number(videoShortsPlayCount60sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right colgroup-5"><span data-bind="text: Number(videoShortsEngagedCount5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                            <td class="align-right colgroup-5" data-bind="class: $parent.revenuePermissions() ? 'colgroup-5' : 'colgroup-5 end'"><span data-bind="text: Number(videoShortsAvgViews).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- ko if: $parent.revenuePermissions -->
                            <td class="align-right colgroup-5 end"><span class="colgroup-5" data-bind="text: Number(videoShortsRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right colgroup-5 end"><span data-bind="text: Number(videoShortsRpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->

                            <!-- ko if: $parent.revenuePermissions -->
                            <td class="align-right colgroup-2" ><span data-bind="text: Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <td class="align-right colgroup-2" ><span data-bind="text: Number(rpm).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                            <!-- /ko -->
                        </tr>
                    <tbody>
                    
                </table>
            </div>

            <!-- /ko -->
     
            <!-- ko if: viewModeSelected() == 'video' -->

            <div id="list-results" class="w-list-results shared-list-header">
                <table class="list-results">
                    <thead>
                        ${this.videoViewHeaders.getHtmlBuild()}
                    </thead>
                    <tbody data-bind="foreach: videoData">
                    <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                        <td class="align-left"><span data-bind="text: brandName"></span></td>
                        
                        <td class="align-left">                        
                            <a class="icon i-ext-link" data-bind="attr: {href: '/article_analysis?viewMode=articleVideoPerformance&keyword=' + videoTitle}, text: videoTitle" target="_blank" ></a>
                        </td>                        
                        
                        <td class="align-right"><span data-bind="text: Number(articleCount).toLocaleString('en-EG')"></span></td>

                        <td class="align-right"><span data-bind="text: Number(plays).toLocaleString('en-EG')"></span></td>
                        <td class="align-right"><span data-bind="text: Number(ctr).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                        <td class="align-right"><span data-bind="text: Number(plays5Sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                        <td class="align-right"><span data-bind="text: Number(plays30Sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                        <td class="align-right"><span data-bind="text: Number(plays60Sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                        <td class="align-right"><span data-bind="text: Number(engaged5sec).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <!-- /ko -->
            `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('videoPerformance');

        let videoViewHeaders = [
            {headerName: "", fieldName: "", subHeaders: [
                {headerName: "Brand", fieldName: "brandName", subHeaders: []},
            ]},
            {headerName: "Output",class: "colgroup-1", fieldName: "", subHeaders: [
                {headerName: "Video Title", fieldName: "videoTitle", subHeaders: []},
                {headerName: "# Art", fieldName: "articleCount", class: "align-right", subHeaders: []},
            ]},            
            {headerName: "Performance",class: "colgroup-4", fieldName: "", subHeaders: [
                {headerName: "Plays", fieldName: "plays", class: "align-right", subHeaders: []},
                {headerName: "CTR", fieldName: "ctr", class: "align-right", subHeaders: []},
                {headerName: "5 Sec Plays", fieldName: "plays5Sec", class: "align-right", subHeaders: []},
                {headerName: "30 Sec Plays", fieldName: "plays30Sec", class: "align-right", subHeaders: []},
                {headerName: "60 Sec Plays", fieldName: "plays60Sec", class: "align-right", subHeaders: []},
                {headerName: "Engaged Views", fieldName: "engaged5sec", class: "align-right", subHeaders: []},
            ]},
        ];
        
        this.videoViewHeaders = new simpleListHeader_template("videoViewHeaders", this.getTemplateViewModel(), this.caller, videoViewHeaders);
        this.videoViewHeaders.getTemplateViewModel().orderBy("plays");
        this.videoViewHeaders.getTemplateViewModel().orderByDirection("DESC");
        this.videoViewHeaders.getTemplateViewModel().orderByAndDirection("plays_DESC");

        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('Selected brands:');
        this.brandsFilter.setLabel("brands");
        this.brandsFilter.setLogoEnabled(true);

        this.intentsFilter = new multipleSelector_template("intentsFilter", this.getTemplateViewModel(), this.caller);
        this.intentsFilter.setLabel("Intents");
        this.intentsFilter.setFilterContainerClass('margin-neg');
        this.intentsFilter.setTagContainerId('selected-intents');
        this.intentsFilter.setTagContainerCaption('Selected intents:');

        this.contentTypesFilter = new multipleSelector_template("contentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypesFilter.setLabel("content types");
        this.contentTypesFilter.setTagContainerId('selected-content_types');
        this.contentTypesFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.countryFilter = new multipleSelector_template("countryFilter", this.getTemplateViewModel(), this.caller);
        this.countryFilter.setTagContainerId('selected-countries');
        this.countryFilter.setTagContainerCaption('Selected Countries:');
        this.countryFilter.setLabel("Countries");

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);

        let date = new Date();
        date.setHours(0,0,0,0);
        let firstOfMonth = new Date(date.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(date.getTime() === firstOfMonth.getTime()){

            firstOfMonth = new Date(date.getFullYear(),date.getMonth() - 1, 1);
            date.setDate(date.getDate() - 1);
        }else{

            date.setDate(date.getDate() - 1);
        }

        this.datesFilter.setDateRange(firstOfMonth, date);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportCsv = new exportDataCsv();
    }

    protected getTemplateName(): string{

        return "videoPerformance_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            dailyData                   : ko.observableArray([]),
            videoData                   : ko.observableArray([]),
            viewModes                   : ko.observableArray([]),
            viewModeSelected            : ko.observable("daily"),
            publishStatuses             : ko.observableArray([]),
            publishStatusSelected       : ko.observable("all"),
            placements                  : ko.observableArray([]),
            placementSelected           : ko.observable("featured"),
            devices                     : ko.observableArray([]),
            deviceSelected              : ko.observable("all"),
            deviceSelectedText          : ko.observable("All"),
            operatingSystems            : ko.observableArray([]),
            operatingSystemSelected     : ko.observable(null),
            outputs                     : ko.observableArray([]),
            outputSelected              : ko.observable("all"),
            placementColumnNumber       : ko.observable(8),
            collapseButtonClass         : ko.observable("i-expand"),
            collapseButtonText          : ko.observable("expand"),
            revenuePermissions          : ko.observable(false),
            selectedRows                : ko.observableArray([]),
            exportDailyData             : function(){ huit_neuf_this.exportDailyData(huit_neuf_this); },
            exportVideoData             : function(){ huit_neuf_this.exportVideoData(huit_neuf_this); },
            exportDailyButtonHidden     : ko.observable(1),
            exportVideoButtonHidden     : ko.observable(1),
            onViewModeChange            : function(data){ huit_neuf_this.onViewModeChange(); },
            onPublishStatusChange       : function(data){ huit_neuf_this.onPublishStatusChange(); },
            onPlacementChange           : function(data){ huit_neuf_this.onPlacementChange(); },
            onOutputChange              : function(data){ huit_neuf_this.onOutputChange(); },
            onDeviceChange              : function(data){ huit_neuf_this.onDeviceChange(data); },
            onOperatingSystemChange     : function(data){ huit_neuf_this.onOperatingSystemChange(data); },
            onCollapseClick             : function(){ huit_neuf_this.onCollapseClick(); },
            onClickRowClick             : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; }
        };
    }

    public getViewModelForRequest(){

        return {
            filter: {
                brands: this.getTemplateViewModel().brandsFilter.selectedItems(),
                intents: this.getTemplateViewModel().intentsFilter.selectedItems(),
                contentTypes: this.getTemplateViewModel().contentTypesFilter.selectedItems(),
                networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
                countries: this.getTemplateViewModel().countryFilter.selectedItems(),
                device: this.getTemplateViewModel().deviceSelected(),
                operatingSystem: this.getTemplateViewModel().operatingSystemSelected(),
                dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().datesFilter.startDate(),
                endDate: this.getTemplateViewModel().datesFilter.endDate(),
                startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
                publishStatus: this.getTemplateViewModel().publishStatusSelected(),
                placement: this.getTemplateViewModel().placementSelected(),
                output: this.getTemplateViewModel().outputSelected(),
            },
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            pagination: this.getTemplateViewModel().pagination,
            videoViewHeaders: this.videoViewHeaders.getViewModelForRequest(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
    }

    public setViewModesItems(){

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setCountriesItems(){

        this.countryFilter.setItems(this.countries);
    }

    public setDevicesItems(){

        this.getTemplateViewModel().devices(this.devices);
    }

    public setOperatingSystemsItems(){

        this.getTemplateViewModel().operatingSystems(this.operatingSystems);
    }

    public setPublishStatusItems(){

        this.getTemplateViewModel().publishStatuses(this.publishStatuses);
    }

    public setPlacementItems(){

        this.getTemplateViewModel().placements(this.placements);
    }

    public setOutputItems(){

        this.getTemplateViewModel().outputs(this.outputs);
    }

    public setBrandFilterItems(departments){

        let groups = [];
        for ( let department of departments){

            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }

        this.brandsFilter.setMultiSectionItems(groups);
        this.brandsFilter.setLabel("Brands");
    }

    public setRevenuePermissions(revenuePermissions){

        this.getTemplateViewModel().revenuePermissions(revenuePermissions);
    }

    public setIntentsFilterItems(items){
        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.intentsFilter.setItems(items);
    }

    public setContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.contentTypesFilter.setMultiSectionItems(groups);
        this.contentTypesFilter.setLabel('Content Types');
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setDailyData(tableData){

        this.getTemplateViewModel().dailyData(tableData);
    }

    public setVideoData(tableData){

        this.getTemplateViewModel().videoData(tableData);
    }

    public setPaginationTotalCount(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    private onPublishStatusChange(){

        this.resetPageNumber();
        this.caller.getListData();
    }

    private onViewModeChange(){

        this.caller.getListData();
    }

    private onPlacementChange(){

        this.resetPageNumber();
        this.caller.getListData();
    }

    private onOutputChange(){

        this.resetPageNumber();
        this.caller.getListData();
    }

    private onDeviceChange(selectedDeviceOption){

        this.getTemplateViewModel().operatingSystemSelected(null);

        this.getTemplateViewModel().deviceSelectedText(selectedDeviceOption.name);

        this.caller.getListData();
    }

    private onOperatingSystemChange(selectedMobileOsOption){

        this.getTemplateViewModel().deviceSelected(null);

        this.getTemplateViewModel().deviceSelectedText(selectedMobileOsOption.name);

        this.caller.getListData();
    }

    public dataReorder(id) {

        this.caller.getListData();
    }

    public resetPageNumber() {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }
    
    private exportDailyData(obj){

        let fileName = "videoPerformanceDaily_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportCsv.exportToCsv(fileName, this.getTemplateViewModel().dailyData());
    }
    
    private exportVideoData(obj){

        this.caller.getVideoDataForCSV();
    }

    private exportVideoDataCSV(data){

        let fileName = "videoPerformanceVideo_" + this.datesFilter.getTemplateViewModel().startDate() + "_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportCsv.exportToCsv(fileName, data);
    }

    public hideExportButtons(){

        this.getTemplateViewModel().exportDailyButtonHidden(1);
        this.getTemplateViewModel().exportVideoButtonHidden(1);
    }

    public showExportButtons(){

        this.getTemplateViewModel().exportDailyButtonHidden(0);
        this.getTemplateViewModel().exportVideoButtonHidden(0);
    }

    private onCollapseClick(){

        if(this.getTemplateViewModel().collapseButtonText() == 'simplify'){

            // The extra 3 columns
            this.getTemplateViewModel().placementColumnNumber(8);
            this.getTemplateViewModel().collapseButtonClass('i-expand');
            this.getTemplateViewModel().collapseButtonText('expand');
        }else{

            // The extra 3 columns
            this.getTemplateViewModel().placementColumnNumber(11);
            this.getTemplateViewModel().collapseButtonClass('i-simplify');
            this.getTemplateViewModel().collapseButtonText('simplify');
        }
    }


    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
        }

        if(typeof params['filter']['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['filter']['publishStatus']);
        }

        if(typeof params['filter']['placement'] !== 'undefined'){

            this.getTemplateViewModel().placementSelected(params['filter']['placement']);
        }

        if(typeof params['filter']['output'] !== 'undefined'){

            this.getTemplateViewModel().outputSelected(params['filter']['output']);
        }

        if(typeof params['filter']['device'] !== 'undefined' && params['filter']['device'] !== null){

            this.getTemplateViewModel().operatingSystemSelected(null);
            this.getTemplateViewModel().deviceSelected(params['filter']['device']);
            this.getTemplateViewModel().deviceSelectedText(this.presetFilter.getFilterTextFromId(this.devices, params['filter']['device']));
        }

        if(typeof params['filter']['operatingSystem'] !== 'undefined' && params['filter']['operatingSystem'] !== null){

            this.getTemplateViewModel().deviceSelected(null);
            this.getTemplateViewModel().operatingSystemSelected(params['filter']['operatingSystem']);
            this.getTemplateViewModel().deviceSelectedText(this.presetFilter.getFilterTextFromId(this.operatingSystems, params['filter']['operatingSystem']));
        }

        this.presetFilter.setMultiSelectorPresetFilters(this.countryFilter, params['filter']['countries']);
        this.presetFilter.setMultiSelectorPresetFilters(this.brandsFilter, params['filter']['brands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.intentsFilter, params['filter']['intents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.contentTypesFilter, params['filter']['contentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['filter']['networkCategories']);
        this.presetFilter.setDates(this.datesFilter, params['filter']['dateFilterType'], params['filter']['startDate'], params['filter']['endDate'], params['filter']['startDateRange'], params['filter']['endDateRange']);
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/videoPerformance_template.ts